// extracted by mini-css-extract-plugin
export default {"icon":"ProfileIcon_icon__ZqYiH"};